
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RiskEfficiencyAnalysis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fundid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareclasscode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countrycode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languagecode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Overview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fundid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fundid"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareclasscode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareclasscode"}}},{"kind":"Argument","name":{"kind":"Name","value":"countrycode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countrycode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languagecode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languagecode"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"producttype"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shareclass"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shclname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"incepdtstd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"identifiers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shclcode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taid"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"performance"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quarter_end"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"perfstatus"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"riskstatistics"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asofdate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bullmkttotabvbm2yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bullmkttotblwbm2yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bullmkttotnom2yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bullmkthitratepct2yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bullmktavgexc2yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bearmkttotabvbm2yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bearmkttotblwbm2yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bearmkttotnom2yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bearmkthitratepct2yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bearmktavgexc2yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totabvbm2yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totblwbm2yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totoftotal2yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tothitratepct2yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totavgexcpct2yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avgexcabvbm2yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avgexcblwbm2yr"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":980}};
    doc.loc.source = {"body":"query RiskEfficiencyAnalysis(\n  $fundid: String!\n  $shareclasscode: String!\n  $countrycode: String!\n  $languagecode: String!\n) {\n  Overview(\n    fundid: $fundid\n    shareclasscode: $shareclasscode\n    countrycode: $countrycode\n    languagecode: $languagecode\n  ) {\n    fundname\n    producttype\n    shareclass {\n      shclname\n      incepdtstd\n      identifiers {\n        fundid\n        shclcode\n        taid\n      }\n      performance {\n        quarter_end {\n          perfstatus\n        }\n      }\n      riskstatistics {\n        asofdate\n        bullmkttotabvbm2yr\n        bullmkttotblwbm2yr\n        bullmkttotnom2yr\n        bullmkthitratepct2yr\n        bullmktavgexc2yr\n        bearmkttotabvbm2yr\n        bearmkttotblwbm2yr\n        bearmkttotnom2yr\n        bearmkthitratepct2yr\n        bearmktavgexc2yr\n        totabvbm2yr\n        totblwbm2yr\n        totoftotal2yr\n        tothitratepct2yr\n        totavgexcpct2yr\n        avgexcabvbm2yr\n        avgexcblwbm2yr\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["RiskEfficiencyAnalysis"] = oneQuery(doc, "RiskEfficiencyAnalysis");
        
